gsap.registerPlugin(ScrollTrigger);

function animateFrom(elem, direction) {
    direction = direction || 1;
    var x = 0,
        y = direction * 100;
    elem.classList.contains("gs_reveal_fromLeft") ? (x = -100, y = 0) : elem.classList.contains("gs_reveal_fromRight") && (x = 100, y = 0), elem.style.transform = "translate(" + x + "px, " + y + "px)", elem.style.opacity = "0", gsap.fromTo(elem, {
        x: x,
        y: y,
        autoAlpha: 0
    }, {
        duration: 2,
        x: 0,
        y: 0,
        autoAlpha: 1,
        ease: "expo",
        overwrite: "auto"
    })
}

function hide(elem) {
    gsap.set(elem, {
        autoAlpha: 0
    })
}
document.addEventListener("DOMContentLoaded", function () {
    gsap.registerPlugin(ScrollTrigger), gsap.utils.toArray(".gs_reveal").forEach(function (elem) {
        hide(elem), ScrollTrigger.create({
            trigger: elem,
            onEnter: function () {
                animateFrom(elem)
            },
            onEnterBack: function () {
                animateFrom(elem, -1)
            },
            onLeave: function () {
                // hide(elem)
                // animateFrom(elem)
                // animateFrom(elem, -1)
            }
        })
    })
}), gsap.to(".section_1 .img_list .list_1", {
    scrollTrigger: {
        trigger: ".section_1",
        scrub: !0,
        start: "center 65%",
        end: "center 60%"
    },
    opacity: 1,
    ease: "none"
}), gsap.to(".section_1 .img_list .list_2", {
    scrollTrigger: {
        trigger: ".section_1",
        scrub: !0,
        start: "center 100%",
        end: "center 95%"
    },
    transform: "scale(1)",
    opacity: 1,
    ease: "none"
}), gsap.to(".section_1 .img_list .list_3", {
    scrollTrigger: {
        trigger: ".section_1",
        scrub: !0,
        start: "center 95%",
        end: "center 90%"
    },
    opacity: 1,
    ease: "none"
}), gsap.to(".section_1 .img_list .list_4", {
    scrollTrigger: {
        trigger: ".section_1",
        scrub: !0,
        start: "center 90%",
        end: "center 85%"
    },
    opacity: 1,
    ease: "none"
}), gsap.to(".section_1 .img_list .list_5", {
    scrollTrigger: {
        trigger: ".section_1",
        scrub: !0,
        start: "center 85%",
        end: "center 80%"
    },
    opacity: 1,
    ease: "none"
}), gsap.to(".section_1 .img_list .list_6", {
    scrollTrigger: {
        trigger: ".section_1",
        scrub: !0,
        start: "center 80%",
        end: "center 75%"
    },
    opacity: 1,
    ease: "none"
}), gsap.to(".section_1 .img_list .list_7", {
    scrollTrigger: {
        trigger: ".section_1",
        scrub: !0,
        start: "center 75%",
        end: "center 70%"
    },
    opacity: 1,
    ease: "none"
}), gsap.to(".section_1 .img_list .list_8", {
    scrollTrigger: {
        trigger: ".section_1",
        scrub: !0,
        start: "center 70%",
        end: "center 65%"
    },
    opacity: 1,
    ease: "none"
});

function isMobile() {
    return window.innerWidth <= 768
}
isMobile() ? molInit() : pcInit();

function pcInit() {
    gsap.to(".section_10 .mask_layer", {
        scrollTrigger: {
            trigger: ".section_10",
            scrub: !0,
            start: "top top"
        },
        opacity: 1,
        ease: "none"
    }), gsap.to(".section_10 .text_box", {
        scrollTrigger: {
            trigger: ".section_10",
            scrub: !0,
            start: "center 70%",
            end: "center 60%"
        },
        opacity: 0,
        ease: "none"
    }), gsap.to(".section_10 .ug_logo", {
        scrollTrigger: {
            trigger: ".section_10",
            scrub: !0,
            start: "center 60%",
            end: "center 55%"
        },
        opacity: 1,
        ease: "none"
    }), gsap.to(".section_10 .mask_layer_bottom", {
        scrollTrigger: {
            trigger: ".section_10",
            scrub: !0,
            end: "center 70%"
        },
        opacity: 1,
        ease: "none"
    })
}